<app-base-dialog [noGap]="true" [noPadding]="true" sizeClass="size-28-75">
	<app-favorieten-list [scrollable]="true" (favorietGeklikt)="sluiten()"></app-favorieten-list>
</app-base-dialog>
